import styled from 'styled-components';

export const PressBanner = styled.section`
    .search-header{
        display:none;
    }
    .media-strong{
        color:#333;
    }
    .row{
        align-items:center;
    }
    .member-board{
        background: transparent;
          box-shadow: none;
      }
      .press-banner{
        padding-bottom:0
      }
      .member-board{
        padding:0;
      }
      a{
        text-decoration: none;
        color: #333;
      }
`;
 
export const PressVideoSection = styled.div`
    background: #F1FEFF 0% 0% no-repeat padding-box;
    padding:50px 0;
`;

export const GreatNonprofitsNews = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding:20px;
    display:flex;
    gap:34px;
    max-width: 996px;
    margin:0 auto 50px auto;

    @media screen and (max-width: 991px){
        flex-direction: column;
        row-gap: 30px;
    }
`;

export const NewsDescription = styled.div`
    padding-top: 25px;
    width: 100%;
    max-width: 466px;

    @media screen and (max-width: 575px){
        padding-top: 0px;
    }
`;
export const VideoSection = styled.div`
flex:1;
`;


export const NewTitle = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 600;
    line-height: 40px;
    margin-bottom: 10px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
`;

export const NewSmallText = styled.span`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:12px;
    font-weight: 400;
    line-height: 21px;
    margin-bottom: 0px;
`;
export const NewText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 400;
    line-height: 21px;
    margin-bottom: 0px;
`;

export const NewsList = styled.div`
    max-width: 996px;
    margin: 0 auto;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 20px;
    padding:20px;
    margin-bottom:50px;
    &:last-child{
        margin-bottom:0px;
    }
`;
export const CardRate = styled.div`
    background: #EFEFEF 0% 0% no-repeat padding-box;
    border-radius: 15px;
    padding:18px 20px;
    margin-bottom:20px;
    &:last-child{
        margin-bottom:0px;
    }
    .press-title {
     color: #01606F;
     text-decoration:none;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 700;
    line-height: 21px;
    margin-bottom: 10px;}
`;

export const PressTitle = styled.h4`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 700;
    line-height: 21px;
    margin-bottom: 10px;
`;


export const PressText = styled.p`
color:#333333;
font-family: "Jost", sans-serif;
font-size:16px;
font-weight: 600;
line-height: 21px;
margin-bottom: 6px;
`;
export const PressSpan = styled.span`
color:#333333;
font-family: "Jost", sans-serif;
font-size:14px; 
font-weight: 400;
line-height: 21px;
margin-bottom: 0px;
`;
export const CardTitle = styled.h3`
color:#333333;
font-family: "Jost", sans-serif;
font-size:20px;
font-weight: 700;
line-height: 29px;
margin-bottom: 20px;
text-align: center;
`;

